import { type ActionItem } from 'shared/ui'
import { type TagsRow } from 'entities/Tags/model/TagsRow'
import { type TagsStore } from 'pages/settings/pages/tags'

export const getTagsTableActions = (
  item: TagsRow,
  TagsStore: TagsStore,
  isUserCanManageTags: boolean
): ActionItem[] => {
  return [
    {
      icon: 'contacts',
      text: 'Show contacts',
      onAction: () => TagsStore.onShowContacts(item.id),
    },
    {
      icon: 'edit',
      text: 'Rename',
      buttonProps: {
        disabled: !isUserCanManageTags,
      },
      onAction: () => TagsStore.tagsModalStore?.onRename(item.id, item.name),
    },
    {
      icon: 'delete',
      text: 'Delete',
      buttonProps: {
        disabled: !isUserCanManageTags,
      },
      onAction: () => {
        TagsStore.setIdsToDelete([item.id])
        TagsStore.tagsModalStore?.onDelete(item.id, item.name)
      },
    },
  ]
}
